<template>
  <button
    class="flex h-18 w-18 cursor-pointer select-none flex-col items-center text-white"
    :aria-expanded="menuOpen"
    @click="menuOpen = !menuOpen"
  >
    <div class="mb-0.5 flex size-full select-none flex-col items-center justify-center gap-0.5 text-[15px]">
      {{ t('ikke3Z8xpqAidzDFLQtdD') }}
      <div class="h-[13px]" aria-disabled="true">
        <drag-handle-icon v-show="!menuOpen" class="fill-white" />
        <close-icon v-show="menuOpen" class="fill-white" />
      </div>
    </div>
  </button>
</template>

<script setup lang="ts">
import CloseIcon from '@/common/assets/icons/close.svg';
import DragHandleIcon from '@/common/assets/icons/drag-handle.svg';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();

const menuOpen = defineModel<boolean>();
</script>
